import Component from '@glimmer/component';

import LinksTo from 'ember-route-state/components/links-to.gjs';

import string from 'rise-ui/helpers/string.js';

export default class LocationDetailLocationsComponent extends Component {
  <template>
    <div class="id-location-detail__location-extra">
      <div class="id-location-detail__related-locations">
        <h4 class="c-section-title id-location-detail__related-locations-label">
          {{string "location-related-locations-heading"}}
        </h4>
        {{#if @location.relatedLocations.length}}
          <div class="c-related-links__links">
            {{#each @location.relatedLocations as | relatedLocation |}}
              <div class="c-related-links__link">
                <LinksTo @route="location-detail" @model={{relatedLocation.id}}>
                  {{~relatedLocation.name~}}
                </LinksTo>
              </div>
            {{/each}}
          </div>
        {{else}}
          <p class="id-catalog-record__no-items-hint">
            {{string "location-no-related-locations-hint"}}
          </p>
        {{/if}}
      </div>
    </div>
  </template>
}
